import React, { useState } from 'react';
import * as IdKey from 'short-uuid';
import { useForm } from "react-hook-form";
import ModalConfirm from '../../utils/form/modalConfirmBase';
import { Grid, TextField, Card, Button, CardContent, FormControl, FormHelperText} from "@material-ui/core";
import Snackbars from "../../componentes/snackbars/SnackBars";
import { yupResolver } from "@hookform/resolvers/yup";
import { getState } from "../../actions/dummy-actions";
import { editRegionalById, updateRegional, createRegional } from '../../actions/regional-actions';
import { ButtonRegional, BorderGreenButton, BorderRedButton } from "../../utils/form/buttonsForm";
import { SelectBasic } from '../../utils/form/selectBasic';
import { styles } from '../styles';
import * as yup from "yup";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";

const defaultValues = {
 code: null,
 status: null,
 name: ''
};

export const STATE = getState();
const EditRegional = ({closeCreate, stateEdit}) => {

    const classes = styles();
    const [openStatus, setOpenStatus] = useState(false);
    const [openCancel, setOpenCancel] = useState(false);
    const [data, setData]= useState(false);
    const [disabledOnsubmit, setDisabledOnsubmit] = useState(false);
   
    const [informationUser, setInformationUser] = useState(defaultValues); 

    const [message, setMessage] = useState({
      description : '',
      textButtonSubmit : '',
      handleClick : () => {} ,
      handleClickOut : () => {},
      oneButtons : false,
      type : '',
      open : false
  })
  
    const [confirm, setConfirm] = useState({
      open: false,
      question: "",
      handleClickOut: () => {},
      handleClick: () => {},
    });
  
    const closeMessage = () => {
      setMessage((anterior) => ({
        ...anterior,
        open: false,
      }));
    };
  
    const closeModal = () => {
      setDisabledOnsubmit(false);
      setConfirm((anterior) => ({
        ...anterior,
        open: false,
      }));
    };

    const handleClickOut = () => {setMessage({...message, open: false});  setDisabledOnsubmit(false); }
    const handleClickClose = () => {
      setMessage({...message, open: false}); 
      setDisabledOnsubmit(false);
      setValue('name');
      setInformationUser(defaultValues)
    }
  
    const cancelConfirm = () => {
      const create = "¿Está seguro que NO desea continuar creando el registro?"
          setMessage({
            description : create,
            textButtonSubmit : 'Aceptar',
            handleClick : () => handleClickOut(),
            handleClickOut: () => handleClickClose(),
            type : 'WARNING',
            open : true
        })
    };

    const cancel = () => {
      closeModal();
      setMessage({
        open: true,
        text: "Registro cancelado",
        type: "warning",
        fontColor: "#BA8A08",
        handleClose: closeMessage,
      });
      setTimeout(() => {
        closeCreate();
      }, 1000);
    };

  const schema = yup.object().shape({
    name: yup.string().required(REQUIRED_MESSAGE).min(4, 'Ingrese mínimo 4 caracteres').max(50, 'ingrese máximo 50 caracteres'),
});

  const { register, handleSubmit, control,  errors, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  const onSubmit = (info) => {
    setDisabledOnsubmit(true)
    setMessage({
      description : "¿Está seguro que desea crear el registro? ",
      textButtonSubmit : 'Aceptar',
      handleClick : () => handleClick(info),
      handleClickOut: () => handleClickClose(),
      type : 'WARNING',
      open : true
  })
  }

  const openModalStatus = () => setOpenStatus(true)

  const handleOnChange = event => {
    const { name, value } = event.target;
    if(name=== 'status' && value === 'INACTIVO' ){
      openModalStatus();
    }
    setInformationUser({ ...informationUser, [name]: value });
  };

  const refresh = () =>  stateEdit(); 

  const handleClick = (data) => {
    setMessage({...message, open: false})
    setConfirm({...confirm, disabled: true});
    setData(true)
    setDisabledOnsubmit(true);
    const bodyCreate ={
      name: data.name,
      code: data.name,
      creationUser: "Developer"
    }
    
   setTimeout(() => {
    
    const create = async() => {
  
      const response = await createRegional(bodyCreate);
      if(response?.status === 200 || response?.status === 201){
       
        refresh();
        setMessage({
          description :  `Regional creada exitosamente`,
          textButtonSubmit : 'Aceptar',
          handleClick : () => handleClickClose() ,
          oneButtons : true,
          type : 'SUCCESS',
          open : true
        })
       
      } 
      else if(response?.status > 399 && response?.status !== 401 && response?.status !==403){
        setMessage({
          description : ERROR_MESSAGE,
          textButtonSubmit : 'ACEPTAR',
          handleClick : () => handleClickClose() ,
          oneButtons : true,
          type : 'WARNING',
          open : true
        })
      }  else {
        setMessage({
          description :  ERROR_MESSAGE,
          textButtonSubmit : 'Aceptar',
          handleClick : () =>  handleClickOut(),
          type : 'WARNING',
          OneButtons : true,
          open : true
        });
      }
    };
    create();
   }, 2000);
     
  }
    
  const buttonDisabled = informationUser.name.length > 0 && !errors.name ;


    return (
        <>
         <Card elevation = {0} style={{background: '#e0f2f7'}}>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)} >
            <Grid container spacing={3} alignItems="center" style = {{background: '#BAE5F9', borderRadius: 15, display: 'flex', justifyContent: 'space-evenly'}}>
              <Grid item xs={12} md={6} lg={4} style={{display: 'flex'}}>
              <FormControl fullWidth shrink={true}  notched={true} size="small">
              <TextField
                fullWidth
                inputRef={register}
                variant="outlined"
                placeholder = 'Nombre de la regional'
                label = "Nombre"
                size = "small"
                InputLabelProps = {{ shrink: true}}
                className = {classes.dropdownMultiple}
                defaultValue=''
                onChange={handleOnChange}
                name="name"
                error={errors.hasOwnProperty('name') && errors['name'].message}                              
              />
                <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                  {errors.hasOwnProperty('name') && errors['name'].message}
                </FormHelperText>
              </FormControl>
              </Grid>
              <Grid item xs={12} md={6} lg={4} style={{display: 'flex'}}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    className={classes.dropdownMultiple}
                    variant="outlined"
                    disabled
                    defaultValue = ''
                    size = 'small'
                    InputLabelProps={{ shrink: true }}
                    inputRef={register}
                    label = 'Código'
                    name = 'code'
                    value={informationUser.name}
                  />
                </FormControl>   
              </Grid>
               <Grid item xs={12} sm={12} lg={4}>
              <ButtonRegional  type="submit" disabled={!buttonDisabled || disabledOnsubmit} className = { classes.create }>FINALIZAR</ButtonRegional>&nbsp;&nbsp;
              <ModalConfirm 
                description = { message.description }
                textButtonSubmit = { message.textButtonSubmit }
                handleClick = { message.handleClick }
                handleClickOut = { message.handleClickOut }
                oneButtons = { message.oneButtons }
                type = { message.type }
                open = { message.open }
              />
            </Grid>
            </Grid>
          </form>
         </CardContent>
        </Card>
        </>
    )
}

export default EditRegional;